import { employees } from "./employees";

export const organizationES_MX = {
	employees,
};
